import { useState, useEffect } from 'react';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData';
import type { ActivityResourceType } from '@confluence/fabric-providers/entry-points/ActivityProvider';
import { getActivityProvider } from '@confluence/fabric-providers/entry-points/ActivityProvider';

export function useActivityProvider() {
	const [activityProvider, setActivityProvider] = useState<
		Promise<ActivityResourceType> | undefined
	>(undefined);
	const { cloudId } = useSessionData();

	useEffect(() => {
		setActivityProvider(getActivityProvider(cloudId));
	}, [cloudId]);

	return activityProvider;
}
